import React, { useState } from "react";
import axios from "axios";

export default function DynamicRows() {
  const [heading, setHeading] = useState("");
  const [morningRows, setMorningRows] = useState([{ field1: "", field2: "" }]);
  const [eveningRows, setEveningRows] = useState([{ field1: "", field2: "" }]);

  // ===== Common handlers =====
  const addRow = (setRows, rows) => {
    setRows([...rows, { field1: "", field2: "" }]);
  };

  const removeRow = (setRows, rows, index) => {
    const newRows = [...rows];
    newRows.splice(index, 1);
    setRows(newRows);
  };

  const handleChange = (setRows, rows, index, field, value) => {
    const newRows = [...rows];
    newRows[index][field] = value;
    setRows(newRows);
  };

  // ===== Submit data =====
  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      heading,
      morning: morningRows,
      evening: eveningRows,
    };

    try {
      const response = await axios.post("https://atblogin.cubixsystems.com/myapp/api/save.php", data);
      alert("Data saved successfully!");
      console.log(response.data);
      window.location.reload();
    } catch (error) {
      alert("Error saving data");
      console.error(error);
    }
  };

  return (
    <div style={styles.container}>
      <h4 style={{ marginBottom: '30px', fontWeight: '600', borderBottom: '1px solid silver', paddingBottom: '8px' }}>Temple Festivals</h4>



      <form onSubmit={handleSubmit}>
        {/* Heading */}
        <div style={styles.headingBox}>
          <input
            type="text"
            value={heading}
            onChange={(e) => setHeading(e.target.value)}
            placeholder="Enter Festival Title"
            style={styles.headingInput}
            required
          />
        </div>
        {/* ========== MORNING SECTION ========== */}
        {/* <h4 style={styles.sectionTitle}></h4> */}
        {morningRows.map((row, index) => (
          <div key={index} style={styles.row}>
            <input
              type="text"
              value={row.field1}
              onChange={(e) => handleChange(setMorningRows, morningRows, index, "field1", e.target.value)}
              placeholder="Enter Festival Details"
              style={styles.input}
              required
            />
            {/* <input
              type="text"
              value={row.field2}
              onChange={(e) => handleChange(setMorningRows, morningRows, index, "field2", e.target.value)}
              placeholder="Morning End"
              style={styles.input}
            /> */}

            <button
              type="button"
              onClick={() => addRow(setMorningRows, morningRows)}
              style={styles.addButton}
            >
              +
            </button>

            {morningRows.length > 1 && (
              <button
                type="button"
                onClick={() => removeRow(setMorningRows, morningRows, index)}
                style={styles.removeButton}
              >
                -
              </button>
            )}
          </div>
        ))}

        {/* ========== EVENING SECTION ========== */}
        {/* <h4 style={styles.sectionTitle}>🌇 Evening Timings</h4> */}
        {/* {eveningRows.map((row, index) => (
          <div key={index} style={styles.row}>
            <input
              type="text"
              value={row.field1}
              onChange={(e) => handleChange(setEveningRows, eveningRows, index, "field1", e.target.value)}
              placeholder="Evening Time"
              style={styles.input}
              required
            />




            <button
              type="button"
              onClick={() => addRow(setEveningRows, eveningRows)}
              style={styles.addButton}
            >
              +
            </button>

            {eveningRows.length > 1 && (
              <button
                type="button"
                onClick={() => removeRow(setEveningRows, eveningRows, index)}
                style={styles.removeButton}
              >
                -
              </button>
            )}
          </div>
        ))} */}
        {/* <input
              type="text"
              value={row.field2}
              onChange={(e) => handleChange(setEveningRows, eveningRows, index, "field2", e.target.value)}
              placeholder="Evening End"
              style={styles.input}
            /> */}
        {/* Submit */}
        <button type="submit" style={styles.submitButton}>
          💾 Save
        </button>
      </form>
    </div>
  );
}

// ===== Styles =====
const styles = {
  container: {
    width: "80%",
    margin: "auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
  },
  headingBox: {
    marginBottom: "20px",
  },
  headingInput: {
    width: "100%",
    padding: "8px",
  },
  sectionTitle: {
    marginTop: "35px",
    marginBottom: "10px",
    color: "#9a9a9aff",
    borderBottom: "1px solid #ccc",
    paddingBottom: "4px",
    fontSize: "11pt",
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "10px",
  },
  input: {
    flex: 1,
    padding: "8px",
  },
  addButton: {
    background: "orange",
    color: "maroon",
    border: "none",
    padding: "8px 10px",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "12pt",
  },
  removeButton: {
    background: "gray",
    color: "white",
    border: "none",
    padding: "8px 10px",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "12pt",
  },
  submitButton: {
    marginTop: "30px",
    background: "maroon",
    color: "white",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};
